<style scoped>
.container {
  margin-top: 24px;
}
</style>

<template lang="pug">
    .grey.lighten-4
        .container
            .vspace.large
            .row
                .col.s12
                    span.title.medium Let's Get Started
            .row
                .col.s12
                    .card
                        .card-content
                            app-address-setup
</template>
<script>
import AppAddressSetup from '@/components/app-address-setup'

export default {
  data () {
    return {}
  },
  components: {
    AppAddressSetup
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-account-setup.vue